export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ07.af05887d.mp3";